/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Field to sort by.
*/
export enum ResourceSortField {
  Id = 'id',
  BackupStatus = 'backupStatus',
  AccountId = 'accountId',
  ResourceName = 'resourceName',
  Environment = 'environment',
  ProviderResourceId = 'providerResourceId',
  SizeBytes = 'sizeBytes',
  SnapshotStorageSizeBytes = 'snapshotStorageSizeBytes',
  EonSnapshotCount = 'eonSnapshotCount',
  NonEonSnapshotCount = 'nonEonSnapshotCount',
  LatestSnapshotTime = 'latestSnapshotTime',
  OldestSnapshotTime = 'oldestSnapshotTime'
}
